$(function(){
	$(".fadeInUp").on("inview", function () {
		$(this).addClass("is-inview");
	});
	$('.initTrans').css('padding-top','115px');
});

$(document).ready(function(){
	if($(window).width() >= 835){
		var pTop = '85px';
	}else{
		var pTop = '12vw';
	}
	setTimeout(function(){
		$('.loading').fadeOut(800)
	},300);
	setTimeout(function(){
		$('.initTrans').animate({
			'padding-top' :pTop,
			'opacity': '1'
		},800,'swing');
	},500);
});

$(window).resize(function(){
	$('.initTrans').css('padding-top','');
});